<template>
  <div v-if="custDetail" class="col-md requestlistdetail__content">
    <div class="requestlistdetail__content--title mb-3">OTHERS</div>
    <div v-for="(item, i) in data" :key="i" :class="styletable.row">
      <div :class="styletable.col1">{{ item.label }}</div>
      <div :class="styletable.col2">:</div>
      <div v-if="!canEdit && item.label !== 'Additional Options'" :class="styletable.col3">{{ item.value }}</div>

      <div
        v-else-if="item.label === 'Additional Options'"
        :class="styletable.col3"
      >
        <b-form-checkbox
          v-model="item.value"
          :disabled="!canEdit"
        >
          Warehouse
        </b-form-checkbox>
      </div>

      <div :class="styletable.col3" 
        v-else-if="canEdit && item.label === 'Insurance'"
      >
        <div class="options__multiselect">
          <multiselect
            v-model="item.fieldDropdown"
            :options="insuranceOption"
            :loading="isLoadingInsuranceList"
            placeholder="Select"
            :name="item.label"
            v-validate="{required : item.show}"
            label="name" selectedLabel=""
            :select-label="''" :deselect-label="''"
            >
            <span slot="noResult">Oops! No elements found.</span>
          </multiselect>
        </div>
        <p v-if="errors.has(item.label)" class="global__texterror text-left py-1">
          {{ errors.first(item.label) }}
        </p>
      </div>

      <div :class="styletable.col3"
        v-else-if="canEdit && item.label === 'Remarks'"
      >
        <b-form-textarea
          rows="3"
          max-rows="5"
          :placeholder="`Input ${item.label}`"
          :name="item.label"
          v-model="item.value"
          v-validate="{required : item.show}"
        />
        <p v-if="errors.has(item.label)" class="global__texterror text-left py-1">
          {{ errors.first(item.label) }}
        </p>
      </div>
    </div>
    <button class="button__bluecorporite mt-3" v-if="isLoadingEditIq">
      <b-spinner small variant="secondary"></b-spinner>
    </button>
    <button class="button__bluecorporite mt-3"
    v-else-if="!canEdit && !isLoadingEditIq" @click="chooseEdit(true)">Edit</button>
    <div class="row m-0 mt-3" v-else-if="canEdit">
      <button class="button__redcorporite mr-3" @click="updateData">Save</button>
      <button class="button__whitesquere" @click="chooseEdit(false)">Cancel</button>
    </div>
 </div>
</template>
<script>
import mixin from '@/mixin/getters/shipment-details'
import { mapGetters } from 'vuex'

export default {
  name: 'Others',
  props: {
    custDetail: Object,
    canEdit: Boolean
  },
  mixins: [mixin],
  data () {
    return {
      form: {},
      styletable: {
        row: 'row m-0 mb-1',
        col1: 'col-md-4 pl-0',
        col2: 'col-md-0',
        col3: 'col-md-5 pl-1 textcolor textbold'
      },
      data: [
        {
          label: 'Insurance',
          payloadVar: 'insurance',
          value: '',
          fieldDropdown: ''
        },
        {
          label: 'Additional Options',
          payloadVar: 'additionalOptions',
          value: false
        },
        {
          label: 'Remarks',
          payloadVar: 'remark',
          value: ''
        }
      ],
      name: 'None',
      warehouse: ''
    }
  },
  computed: {
    ...mapGetters({
      insuranceOption: 'insurance/insuranceList',
      isLoadingInsuranceList: 'insurance/isLoadingInsuranceList',

      editIq: 'instantQuote/editIq',
      errorEditIq: 'instantQuote/errorEditIq',
      isLoadingEditIq: 'instantQuote/isLoadingEditIq'
    }),
    getInsurace () {
      return {...this.insuranceOption, ...this.custDetail}
    },
    dataInsurance () {
      return this.insuranceOption
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      await this.$store.dispatch('insurance/INSURANCE_LIST')

      this.form = Object.assign({}, this.custDetail.details.others)

      // Insurance
      const insurance = this.insuranceOption.filter(item => item.id === this.custDetail.details.others.insurance)[0]
      this.data[0].value = insurance ? insurance.name : this.custDetail.details.others.insurance === 0 ? '-' : this.custDetail.details.others.insurance
      this.data[0].fieldDropdown = insurance

      // Additional Options
      this.data[1].value = this.custDetail.details.others.additionalOptions.warehouse

      // Remarks
      this.data[2].value = this.custDetail.details.others.remark !== null ? this.custDetail.details.others.remark : '-'
    },
    chooseEdit (data) {
      this.$emit('chooseEdit', data)
      this.init()
    },
    chooseDropdown (item) {
      if (item.label === 'Product Type') {
        this.data[3].show = item.fieldDropdown.value === 'DG'
        this.data[3].value = ''
      }
    },
    updateData () {
      this.data.forEach((item) => {
        // eslint-disable-next-line no-new-object
        const data = new Object()
        if (item.fieldDropdown && item.label === 'Insurance') {
          data[item.payloadVar] = item.fieldDropdown.id
          this.form = Object.assign(this.form, data)
        } else if (item.label === 'Additional Options') {
          data[item.payloadVar] = { warehouse: item.value }
          this.form = Object.assign(this.form, data)
        } else {
          data[item.payloadVar] = item.value
          this.form = Object.assign(this.form, data)
        }
      })

      // Remove unnecessary attributes
      delete this.form.carrierName
      delete this.form.orderNumber
      delete this.form.shipmentId
      const {requestNumber: _, ...newObj} = this.form
      const payload = {
        editable: 'others',
        data: newObj
      }

      // Validate and send the payload
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('instantQuote/PUT_EDIT_IQ', {
            id: this.$route.params.id_iq,
            payload
          }).then(() => {
            if (!this.errorEditIq) {
              this.$store.dispatch('instantQuote/FETCH_IQ_BY_ID', this.$route.params.id_iq)
              this.$emit('chooseEdit', false)
            }
          })
        }
      })
    }
  },
  created () {
    this.$eventHub.$on('reset-data', this.resetData)
  },
  beforeDestroy () {
    this.$eventHub.$off('reset-data')
  },
  watch: {
    dataInsurance (data) {
      if (this.custDetail.id_insurance === 1 || this.custDetail.id_insurance === 2) {
        data.forEach(element => {
          if (element.id === this.custDetail.id_insurance) {
            this.name = element.name
          }
        })
      } else if (this.custDetail.id_insurance === 3 || this.custDetail.id_insurance === null) {
        if (this.custDetail.option_insurance === '1' || this.custDetail.option_insurance === true) {
          this.name = data[0].name
        } else {
          this.name = 'None'
        }
      } else {
        this.name = 'None'
      }
    },
    custDetail (data) {
      if (data) {
        this.init()
      }
    }
  }
}
</script>
<style scoped>
.options__multiselect {
  .multiselect__placeholder {
    font-size: 14px;
  }
  .multiselect__tags {
    padding-top: 0;
    min-width: 70px;
  }
  .multiselect__single {
    font-size: 14px;
    color: #1D3354;
    padding-top: 3px;
  }
}

.form-control {
  font-size: 12px;
  font-weight: 400;
  color: #686868;
  overflow-y: auto !important;
  border: 1px solid #a9a9a9;
  border-radius: 0px;
  &:disabled {
    background-color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/requestList/detail-instant-quote/tabs-detail/Others.vue